<template>
  <div class="max-h-[45%] overflow-y-auto bg-[#ffffff] border-t border-[#E5E5E5] px-[16px] py-[10px]">
    <div v-if="isLoading" class="text-sm text-[#9A9A9A]">Cargando comandos...</div>

    <div v-else-if="groups.length === 0" class="text-sm text-[#9A9A9A]">
      Sin comandos que coincidan.
    </div>

    <div v-else>
      <div v-for="group in groups" :key="group.category" class="mb-[8px]">
        <div class="text-xs font-bold text-[#9A9A9A] uppercase mb-[4px]">
          {{ categoryLabel(group.category) }}
        </div>
        <button
          v-for="(cmd, i) in group.commands"
          :key="cmd.id"
          type="button"
          class="block w-full text-left px-[10px] py-[8px] rounded-[10px] bg-transparent border-transparent hover:bg-[#F2F2F2]"
          :class="{ 'bg-[#F2F2F2]': isFirst(group.category, i) }"
          @click="$emit('select', cmd)"
        >
          <span class="block text-[#2E2E2E] text-sm">{{ cmd.label }}</span>
          <span v-if="cmd.description" class="block text-xs text-[#6B6B6B]">{{ cmd.description }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
const CATEGORY_LABELS = {
  analisis: 'Análisis',
  programacion: 'Programación',
  conocimiento: 'Conocimiento',
  presentaciones: 'Presentaciones',
  presentacion: 'Presentaciones',
  decks: 'Presentaciones'
}

export default {
  name: 'ChatCommandPalette',
  props: {
    commands: {
      type: Array,
      required: true
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  emits: ['select'],
  computed: {
    // Group by category, preserving the order categories first appear.
    groups() {
      const groups = []
      for (const cmd of this.commands) {
        const category = cmd.category || ''
        let group = groups.find(g => g.category === category)
        if (!group) {
          group = { category, commands: [] }
          groups.push(group)
        }
        group.commands.push(cmd)
      }
      return groups
    }
  },
  methods: {
    categoryLabel(category) {
      if (CATEGORY_LABELS[category]) return CATEGORY_LABELS[category]
      if (!category) return 'Comandos'
      return category.charAt(0).toUpperCase() + category.slice(1)
    },
    // Highlight the first command overall — it's what Enter submits.
    isFirst(category, i) {
      return i === 0 && this.groups.length > 0 && this.groups[0].category === category
    }
  }
}
</script>
